/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import PropTypes from 'prop-types';

import { LinkElement } from '@els/els-react--link-element';

import './NamedUser.scss';

function NamedUser({ userName, userLinkHandler, openLogoutDialog, closeFlyout }) {
  return (
    <>
      {userName !== undefined && (
        <div id="named-user-username-list-item">
          <p className="u-els-font-size-h4 u-els-margin-bottom-3o4" aria-hidden="true">
            {userName}
          </p>
          <p className="u-els-font-size-h4 u-els-margin-bottom-3o4 sr-only" tabIndex="0">
            Logged in as {userName}
          </p>
        </div>
      )}
      <ul>
        <li className="u-els-margin-bottom-1o2 u-els-font-size-body">
          <LinkElement
            iconSprite="Researcher"
            iconSize="xs"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              userLinkHandler();
              if (typeof closeFlyout === 'function') {
                closeFlyout();
              }
            }}
            a11y={{ name: 'Profile', description: 'Go to profile page' }}>
            Profile
          </LinkElement>
        </li>
        <li className="u-els-margin-bottom-1o2 u-els-font-size-body">
          <LinkElement
            iconSprite="LogOut"
            iconSize="xs"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              openLogoutDialog();
              if (typeof closeFlyout === 'function') {
                closeFlyout();
              }
            }}
            a11y={{ name: 'Logout', description: 'Logout from the application' }}>
            Sign out
          </LinkElement>
        </li>
      </ul>
    </>
  );
}

NamedUser.propTypes = {
  userName: PropTypes.string,
  userLinkHandler: PropTypes.func.isRequired,
  openLogoutDialog: PropTypes.func.isRequired,
  closeFlyout: PropTypes.func,
};

export default NamedUser;
